import React from 'react';
import { Stack } from '@fluentui/react';
import { useHistory } from 'react-router-dom';
import BorderIcon from '../../../components/BorderIcon';
import CustomBreadCrumbs from '../../../components/CustomBreadcrumbs';
import { COLORS } from '../../../utility/tasks/colors';
import { stackTokens } from '../../../utility/tasks/styles';
import SettingsMenu from '../../settings/SettingsMenu';
import { ActionContext } from '../../../context/ActionContext';

const HeaderAttchDocuments = () => {
	const { isLoading, setIsLoading } = React.useContext(ActionContext);

	const navigate = useHistory();

	const HeaderAttchDocumentStyle = {
		height: '35px',
		padding: '0px 8px',
	};

	const handleBackIconClick = () => {
		if (!isLoading) {
			navigate.replace('/home');
		}
	};

	return (
		<Stack
			horizontal
			tokens={stackTokens}
			style={{
				paddingRight: '.3rem',
			}}
		>
			<BorderIcon
				iconStyles={{ color: COLORS.OUTLOOK_PRIMARY_BUTTON_COLOR, fontWeight: 'bold', fontSize: '18px' }}
				parentStyles={{ margin: '0 0 0.2rem 1px' }}
				iconName="Back"
				onClick={handleBackIconClick}
			/>

			<CustomBreadCrumbs />

			<SettingsMenu
				HeaderAttchDocumentStyle={HeaderAttchDocumentStyle}
				isLoading={isLoading}
				setIsLoading={setIsLoading}
			/>
		</Stack>
	);
};

export default React.memo(HeaderAttchDocuments);
